'use client';
import React, { Suspense } from 'react';
import SignupLayout from './SignupLayout';

const Signup = () => {
  return (
    <Suspense>
      <SignupLayout />
    </Suspense>
  );
};

export default Signup;
